{
  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".logo_rows");
    if (!container) return;
    const boxes = Array.from(container.querySelectorAll(".LOGO_WRP"));
    const CLONE_COUNT = 3;
    for (let i = 0; i < CLONE_COUNT; i++) {
      boxes.forEach((box) => {
        container.appendChild(box.cloneNode(true));
      });
    }
    const scrollDistance = container.scrollWidth / 2;
    const SPEED = 50;
    const duration = scrollDistance / SPEED;
    const animation = gsap.to(container, {
      x: -scrollDistance,
      duration: duration,
      ease: "linear",
      repeat: -1,
    });
    container.addEventListener("mouseenter", () => animation.pause());
    container.addEventListener("mouseleave", () => animation.resume());
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".Video_Holder");
    const allVideos = document.querySelectorAll(".Video_Holder video");

    function pauseAllVideos() {
      allVideos.forEach((video) => {
        video.pause();
        video.currentTime = 0;
        const playIcon = video
          .closest(".Video_Holder")
          .querySelector(".play-btn-hldr");
        playIcon.style.display = "flex";
      });
    }
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const playIcon = box.querySelector(".play-btn-hldr");
      box.addEventListener("click", function () {
        if (video.paused) {
          pauseAllVideos();
          video.play();
          playIcon.style.display = "none";
        } else {
          video.pause();
          playIcon.style.display = "flex";
        }
      });
      video.addEventListener("play", function () {
        playIcon.style.display = "none";
      });
      video.addEventListener("pause", function () {
        playIcon.style.display = "flex";
      });
      video.addEventListener("ended", function () {
        video.currentTime = 0;
        video.load();
        playIcon.style.display = "flex";
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(
      ".faqs__rows .accordion_cus",
    );
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".faqs__rows .acco_cus_item");
      // if (items.length > 0) {
      //   items[0].classList.add("open");
      // }
      items.forEach((item) => {
        const header = item.querySelector(".faqs__rows .acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const galleryTabs = document.querySelectorAll(".tabs-nav-product");
    galleryTabs.forEach((gallery) => {
      const tabs = gallery.querySelectorAll(".tabs-nav .tab-nav-tem");
      const images = gallery.querySelectorAll(".tabs-content .tabs_product");
      if (tabs.length > 0 && images.length > 0) {
        tabs[0].classList.add("active");
        images[0].classList.add("active");
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          tabs.forEach((t) => t.classList.remove("active"));
          images.forEach((img) => img.classList.remove("active"));
          tab.classList.add("active");
          if (images[index]) {
            images[index].classList.add("active");
          }
        });
      });
    });
  });
}


document.addEventListener("DOMContentLoaded", () => {

  const buttons = document.querySelectorAll(".direct-to-card");

  buttons.forEach(button => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();

      // 🔒 prevent double click
      if (button.classList.contains("loading")) return;

      button.classList.add("loading");
      button.style.opacity = "0.6";
      button.style.pointerEvents = "none";

      const variantId = button.getAttribute("data-variant-id");
      const shippingText = button.getAttribute("data-shipping-delay");

      try {

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  Shipping: shippingText
                }
              }
            ]
          }),
        });

        if (!response.ok) throw new Error('Failed to add product');

        const cart = await fetch('/cart.js').then(res => res.json());

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                cart,
                source: 'custom-add-to-cart',
              },
            },
          })
        );

        document.dispatchEvent(new CustomEvent('cart:open'));

      } catch (error) {
        console.error('Cart error:', error);
      } finally {
        // ✅ always reset (success or error)
        button.style.opacity = "1";
        button.style.pointerEvents = "auto";
        button.classList.remove("loading");
      }

    });
  });

});


document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', async function (e) {

    const atcButton = e.target.closest('featured-product-information add-to-cart-component button');

    if (!atcButton) return;

    e.preventDefault();

    let total_items = [];

    const checkedVariant = document.querySelector('input[type="radio"]:checked');

    if (!checkedVariant) return;

    const relevantProducts = checkedVariant.getAttribute('data-relevant-products');
    const relevantShipping = checkedVariant.getAttribute('data-relevant-shipping');


    if (!relevantProducts) return;

    const variantPicker = relevantProducts.split(',');
    const shippingMessages = relevantShipping ? relevantShipping.split('.') : [];

    const delayshipping = document.querySelectorAll('.variant-picker__form input[type=radio]')
    let delayshippingtext = '';
    delayshipping.forEach((item) => {

      if (item.getAttribute('data-relevant-delay-shipping')) {
        delayshippingtext = item.getAttribute('data-relevant-delay-shipping')

      }
    })

    const sellingPlanInput = document.querySelector('input[name="selling_plan"]:checked');
    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : null;

    variantPicker.forEach((item, index) => {

      let shippingText = '';

      if (variantPicker.length > 1 && index === 1) {
        // second item in bundle → use delay shipping text
        shippingText = delayshippingtext;
      } else {
        // default behavior
        shippingText = shippingMessages[index] ? shippingMessages[index].trim() + '.' : '';
      }

      const cartItem = {
        id: item,
        quantity: 1,
        properties: {
          Shipping: shippingText
        }
      };

      // Only attach selling_plan if one is selected
      if (sellingPlanId && index === 0) {
        cartItem.selling_plan = sellingPlanId;
      }

      total_items.push(cartItem);

      // total_items.push({
      //   id: item,
      //   quantity: 1,
      //   properties: {
      //     Shipping: shippingText
      //   }
      // });

    });

    try {

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: total_items }),
      });

      if (!response.ok) throw new Error('Failed to add products');

      const cart = await fetch('/cart.js').then((res) => res.json());

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              cart,
              source: 'bundle-add-script',
            },
          },
        })
      );

    } catch (error) {
      console.error('Cart error:', error);
    }

  });

});